export const getElementPathByDroppableId = (droppableId: string) => {
  return droppableId
    .split('_')
    .map(item => Number(item.replace(/(tabId|containerId|lineId):/g, '')))
}
